import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "./SectionTitle";
import { portfolio } from "../content/home";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] } }),
};

const Portfolio = () => {
  return (
    <section id="projeler" className="relative scroll-mt-24 py-24">
      <div className="mx-auto max-w-7xl container-px">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="section-eyebrow mb-4">
          <span className="h-px w-8 bg-brand-500" /> {portfolio.eyebrow}
        </motion.div>

        <motion.div variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}>
          <SectionTitle lead={portfolio.title.lead} accent={portfolio.title.accent} tail={portfolio.title.tail} className="max-w-2xl" />
        </motion.div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2">
          {portfolio.projects.map((p, i) => (
            <motion.a
              key={p.title}
              href={p.url}
              target={p.url !== "#" ? "_blank" : undefined}
              rel="noopener noreferrer"
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className={`group relative overflow-hidden rounded-2xl border border-black/10 bg-white/60 p-7 transition-all duration-500 hover:border-black/20 hover:bg-white/80 dark:border-white/10 dark:bg-white/[0.02] dark:hover:border-white/20 dark:hover:bg-white/[0.04] ${
                p.featured ? "sm:col-span-2" : ""
              }`}
            >
              <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-brand-700/20 opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
              <div className="flex items-start justify-between gap-4">
                <span className="font-mono text-xs text-brand-500">0{i + 1}</span>
                <svg
                  viewBox="0 0 512 512"
                  className="h-5 w-5 -rotate-45 text-gray-400 transition-transform duration-300 group-hover:rotate-0 group-hover:text-gray-900 dark:text-white/40 dark:group-hover:text-white"
                  fill="currentColor"
                >
                  <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" />
                </svg>
              </div>
              <h3 className="mt-4 font-display text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white">
                {p.title}
              </h3>
              <p className="mt-3 max-w-2xl text-sm text-gray-700 dark:text-white/70">{p.desc}</p>
              <div className="mt-5 flex flex-wrap gap-1.5">
                {p.stack.map((s) => (
                  <span key={s} className="chip">{s}</span>
                ))}
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;